let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k7BTo")).then(() => parcelRequire('6ZR0a'));